module.exports = __webpack_public_path__ + "img/231.feb5de4f.png";